/**
 * Back closes the top-most overlay (a panel over a screen) instead of leaving the screen under it. An overlay adds one history entry
 * while it is open; Back pops it and closes the overlay; closing it with its own button takes the entry away again. The screens'
 * own navigation (nav.ts) ignores these entries because they carry the same depth as the screen they sit on.
 */
const stack: symbol[] = [];
let ignorePops = 0;

export function registerOverlay(onClose: () => void): () => void {
  const id = Symbol("overlay");
  let popped = false;
  stack.push(id);
  history.pushState({ ...(history.state ?? {}), overlay: true }, "");
  const onPop = () => {
    if (ignorePops > 0) {
      ignorePops--; // our own history.back() below
      return;
    }
    if (stack[stack.length - 1] !== id) return; // an overlay above this one takes the Back first
    popped = true;
    stack.pop();
    onClose();
  };
  window.addEventListener("popstate", onPop);
  return () => {
    window.removeEventListener("popstate", onPop);
    if (popped) return;
    const at = stack.indexOf(id);
    if (at >= 0) stack.splice(at, 1);
    if (history.state?.overlay) {
      ignorePops++;
      history.back();
    }
  };
}
